<script>

/**
 <svg xmlns="http://www.w3.org/2000/svg" style="width:100%">
 <g stroke="red" fill="none" stroke-width="1" fill-opacity="1">
 <path id="xxx" d="M706,91 C978,91 1221,100 1384,114"
 ></path></g>
 </svg>

 var a = document.getElementById('xxx');
 var pt_start = a.getPointAtLength(0);
 var l = a.getTotalLength();
 var v = [];
 for (var i = 100; i > 0; i-=1) {
	var pt = a.getPointAtLength(i / 100 * l);
  var y = -(pt.y - 114);
  y = y * 0.9;
  //y = (y / 23) * 100;
	y = Math.round(y * 10) / 10;
  v.push(y);
}
 var v2 = v.concat([...v].reverse());


 console.log(v2);



 */
const curve2 = [0, 0.5, 1, 1.5, 2, 2.5, 2.9, 3.4, 3.8, 4.3, 4.7, 5.1, 5.5, 5.9, 6.3, 6.7, 7.1, 7.4, 7.8, 8.1, 8.5, 8.8, 9.2, 9.5, 9.8, 10.1, 10.4, 10.7, 11, 11.3, 11.6, 11.9, 12.2, 12.4, 12.7, 13, 13.2, 13.5, 13.7, 14, 14.2, 14.4, 14.6, 14.9, 15.1, 15.3, 15.5, 15.7, 15.9, 16.1, 16.3, 16.4, 16.6, 16.8, 17, 17.1, 17.3, 17.5, 17.6, 17.8, 17.9, 18, 18.2, 18.3, 18.4, 18.6, 18.7, 18.8, 18.9, 19, 19.1, 19.3, 19.4, 19.4, 19.5, 19.6, 19.7, 19.8, 19.9, 19.9, 20, 20.1, 20.1, 20.2, 20.3, 20.3, 20.4, 20.4, 20.5, 20.5, 20.5, 20.6, 20.6, 20.6, 20.6, 20.7, 20.7, 20.7, 20.7, 20.7, 20.7, 20.7, 20.7, 20.7, 20.7, 20.6, 20.6, 20.6, 20.6, 20.5, 20.5, 20.5, 20.4, 20.4, 20.3, 20.3, 20.2, 20.1, 20.1, 20, 19.9, 19.9, 19.8, 19.7, 19.6, 19.5, 19.4, 19.4, 19.3, 19.1, 19, 18.9, 18.8, 18.7, 18.6, 18.4, 18.3, 18.2, 18, 17.9, 17.8, 17.6, 17.5, 17.3, 17.1, 17, 16.8, 16.6, 16.4, 16.3, 16.1, 15.9, 15.7, 15.5, 15.3, 15.1, 14.9, 14.6, 14.4, 14.2, 14, 13.7, 13.5, 13.2, 13, 12.7, 12.4, 12.2, 11.9, 11.6, 11.3, 11, 10.7, 10.4, 10.1, 9.8, 9.5, 9.2, 8.8, 8.5, 8.1, 7.8, 7.4, 7.1, 6.7, 6.3, 5.9, 5.5, 5.1, 4.7, 4.3, 3.8, 3.4, 2.9, 2.5, 2, 1.5, 1, 0.5, 0, 0, 0, 0];

export default {
  name: "Progress",
  props: {
    duration: Number,
    blocked: Boolean,
    perspectiveStart: String
  },
  data() {
    return {

      timer: 0,
      timerFrmt: () => {
        let secNum = parseInt(this.timer, 10);
        let minutes = Math.floor(secNum / 60);
        let seconds = secNum - (minutes * 60);
        if (minutes < 10) {
          minutes = '0' + minutes;
        }
        if (seconds < 10) {
          seconds = '0' + seconds;
        }
        return minutes + ':' + seconds;
      },

      perspective: this.perspectiveStart,

      isFull: window.appIsFullScreen,
      isPaused: false,
      showAlert: false,
      blink: false,

      // abspielknoepfe
      playCar: {
        cx: -100,
        cy: -100,
        pos: (percent) => {
          this.playCar.cx = percent + '%';
          this.playCar.cy = 25 + curve2[Math.round(percent * 2)];
          this.ctrlKey.cx = 'left:' + Math.min(percent, 92) + '%';
        }
      },
      playBike: {
        cx: -100,
        cy: -100,
        pos: (percent) => {
          this.playBike.cx = percent + '%';
          this.playBike.cy = 13 + curve2[Math.round(percent * 2)];
          this.ctrlKey.cx = 'left:' + Math.min(percent, 92) + '%';
        }
      },
      ctrlKey: {
        cx: 'left:-100%'
      },

      // sichtbare segmente auf den Strahlen
      clippingsCar: [],
      clippingsBike: [],

      // entdeckte fragen
      discoveredCar: {},
      discoveredBike: {}

    }
  },
  methods: {

    buzz(
        second,
        perspective,
        duration,
        id
    ) {
      console.log('question buzzerd', perspective, second, duration, id);
    },

    // frage start (egal ob sichtbar)
    question(
        show,
        blink
    ) {
      // console.log('situation start', blink, show);

      this.showAlert = show;
      this.blink = blink;
    },

    // frage vorbei, abspielknopf wieder normal
    questionEnd(
        c = false,
        second,
        perspective,
        duration,
        id
    ) {
      console.log('situation end');

      this.showAlert = false;
      if (c) {

        if (isNaN(duration) || isNaN(second)) {
          return;
        }

        let percent = second / duration * 100;
        if (this.perspective === 'car') { // CAR
          if (!this.discoveredCar[id]) {
            this.discoveredCar[id] = {
              cx: percent + '%',
              cy: 15 + curve2[Math.round(percent * 2)]
            };
          }
        } else { // BIKE
          if (!this.discoveredBike[id]) {
            this.discoveredBike[id] = {
              cx: percent + '%',
              cy: 5 + curve2[Math.round(percent * 2)]
            };
          }
        }
      }
    },

    // bool
    paused(state) {
      console.log('paused', state);
      this.isPaused = state;
    },

    full(state) {
      console.log('full', state);
      this.isFull = state;
    },

    // auf kurz (~0.5s) nach letzter frage (egal ob discovered/welcher strahl)
    rewind(
        second,
        duration
    ) {
      console.log('rewind', second);

      // remove fully rewinded segments
      this.clippingsCar = this.clippingsCar.filter(clipping => clipping.start <= second);
      this.clippingsBike = this.clippingsBike.filter(clipping => clipping.start <= second);

      // crop partially matched
      this.clippingsCar.filter(clipping => clipping.upto > second).forEach((clipping) => {
        clipping.width = ((second - clipping.start) / duration * 100) + '%';
        clipping.upto = second;
      });
      this.clippingsBike.filter(clipping => clipping.upto > second).forEach((clipping) => {
        clipping.width = ((second - clipping.start) / duration * 100) + '%';
        clipping.upto = second;
      });

      // create a new segment
      let percent = second / duration * 100;
      if (this.perspective === 'car') {
        this.clippingsCar.push({pos: percent + '%', width: '0', start: second, upto: second});
      } else {
        this.clippingsBike.push({pos: percent + '%', width: '0', start: second, upto: second});
      }
    },

    tick(
        second,
        perspective,
        duration
    ) {
      // console.log(second, duration);

      this.timer = second;

      let current;
      let percent = second / duration * 100;

      if (isNaN(percent)) {
        return;
      }

      if (perspective === 'car') {
        current = this.clippingsCar[this.clippingsCar.length - 1];
        this.playCar.pos(percent);
      } else {
        current = this.clippingsBike[this.clippingsBike.length - 1];
        this.playBike.pos(percent);
      }

      if (current && current.start <= second) {
        let percentWidth = (second - current.start) / duration * 100;
        current.width = percentWidth + '%';
        current.upto = second;
      }
    },

    // switch perspective
    switch(
        second,
        perspective,
        duration
    ) {
      this.questionEnd();
      this.perspective = perspective;
      let percent = second / duration * 100;

      console.log('switch to ' + perspective + ' at ' + second);

      if (isNaN(percent)) {
        return;
      }

      let current;
      // begin new segment
      if (perspective === 'car') {
        current = this.clippingsCar[this.clippingsCar.length - 1];
        if (!current || current.pos != percent + '%') {
          this.clippingsCar.push({pos: percent + '%', width: '0', start: second, upto: second});
        }
        this.playCar.pos(percent);
      } else {
        current = this.clippingsBike[this.clippingsBike.length - 1];
        if (!current || current.pos != percent + '%') {
          this.clippingsBike.push({pos: percent + '%', width: '0', start: second, upto: second});
        }
        this.playBike.pos(percent);
      }
    },

    tutorial() {
      var temp = this.clippingsCar;
      this.clippingsCar = this.clippingsBike;
      this.clippingsBike = temp;
    }

  },
  mounted() {
    this.switch(0, this.perspectiveStart, 1000);
  }
}
</script>

<template>

  <div class="pbContainer" v-bind:class="[perspective]">

    <div class="pbMargin1"></div>

    <div class="pbInner1">

      <span class="time">
        {{ timerFrmt() }} / 02:29
      </span>

      <!-- DEFS -->
      <svg style="position: absolute; height: 0;">
        <defs>
          <path id="exclaMark"
                d="M94.1687091,64.5304659 L59.1128184,6.22222222 C56.7892291,2.30824373 52.6471786,0 48,0 C43.3528214,0 39.2107709,2.30824373 36.8871816,6.22222222 L1.83129092,64.5304659 C-0.593323998,68.5448029 -0.593323998,73.3620072 1.7302653,77.4767025 C4.0538546,81.5913978 8.2969307,84 12.9441093,84 L83.0558907,84 C87.8040949,84 91.9461454,81.5913978 94.2697347,77.4767025 C96.593324,73.3620072 96.593324,68.5448029 94.1687091,64.5304659 Z M48.5,71 C45.4444444,71 43,68.5555556 43,65.5 C43,62.4444444 45.4444444,60 48.5,60 C51.5555556,60 54,62.4444444 54,65.5 C54,68.5555556 51.5555556,71 48.5,71 Z M54.8967772,29.4941376 L52.9355435,52.3892493 C52.7290978,54.5452912 50.7678642,56.1879898 48.6001848,55.9826525 C46.6389511,55.7773152 45.0906088,54.2372853 44.9873859,52.3892493 L43.0261523,29.4941376 C42.7164838,26.2087404 45.1938316,23.3340178 48.496962,23.0260119 C51.8000924,22.7180059 54.6903315,25.1820538 55,28.467451 C54.8967772,28.775457 54.8967772,29.1861316 54.8967772,29.4941376 Z"></path>

          <path id="exclaMarkSmall"
                transform="scale(0.25, 0.25)"
                d="M94.1687091,64.5304659 L59.1128184,6.22222222 C56.7892291,2.30824373 52.6471786,0 48,0 C43.3528214,0 39.2107709,2.30824373 36.8871816,6.22222222 L1.83129092,64.5304659 C-0.593323998,68.5448029 -0.593323998,73.3620072 1.7302653,77.4767025 C4.0538546,81.5913978 8.2969307,84 12.9441093,84 L83.0558907,84 C87.8040949,84 91.9461454,81.5913978 94.2697347,77.4767025 C96.593324,73.3620072 96.593324,68.5448029 94.1687091,64.5304659 Z M48.5,71 C45.4444444,71 43,68.5555556 43,65.5 C43,62.4444444 45.4444444,60 48.5,60 C51.5555556,60 54,62.4444444 54,65.5 C54,68.5555556 51.5555556,71 48.5,71 Z M54.8967772,29.4941376 L52.9355435,52.3892493 C52.7290978,54.5452912 50.7678642,56.1879898 48.6001848,55.9826525 C46.6389511,55.7773152 45.0906088,54.2372853 44.9873859,52.3892493 L43.0261523,29.4941376 C42.7164838,26.2087404 45.1938316,23.3340178 48.496962,23.0260119 C51.8000924,22.7180059 54.6903315,25.1820538 55,28.467451 C54.8967772,28.775457 54.8967772,29.1861316 54.8967772,29.4941376 Z"></path>

          <path
              id="bar1"
              d="M706,1062 C978.859428,1062 1222.84319,1070.85176 1385,1085 L1385,1092 C1222.84546,1077.82925 978.860694,1068.97741 706,1069 C446.819235,1068.97867 213.689258,1076.96419 51.9943101,1089.68786 L51.9942302,1082.69143 C213.686672,1069.98679 446.817797,1062 706,1062 Z"
              transform="translate(718.500000, 1077.000000) scale(1, -1) translate(-770.500000, -14.000000) "
          ></path>

          <path
              d="M1366.00538,1003 L1366.00538,1015.90242 C1204.2728,1028.67117 970.71745,1036.92972 711.001225,1036.92972 C450.214421,1036.92972 215.802258,1028.60275 54,1015.10851 L54,1004.06684 C215.804287,1017.31228 450.21555,1024.65305 711.001225,1024.92972 C970.718655,1024.65248 1204.27497,1016.3805 1366.00538,1003 Z"
              id="pCar"></path>

          <path
              d="M1366.00538,1003 L1366.00538,1015.90242 C1204.2728,1028.67117 970.71745,1036.92972 711.001225,1036.92972 C450.214421,1036.92972 215.802258,1028.60275 54,1015.10851 L54,1004.06684 C215.804287,1017.31228 450.21555,1024.65305 711.001225,1024.92972 C970.718655,1024.65248 1204.27497,1016.3805 1366.00538,1003 Z"
              id="pBike"></path>

          <path
              d="M12.8958167,1.44 L15.4956667,1.44 C15.9466167,1.44 16.3125,1.07664 16.3125,0.6288 C16.3125,0.30144 16.3125,0 16.3125,0 C16.3125,0 13.8571667,0 12.5376667,0 C12.41345,0 12.296,0.02736 12.1911167,0.07632 C12.0466,0.1344 11.9194833,0.23904 11.8358667,0.38352 L8.03348333,6.92352 C7.34618333,6.63792 6.59121667,6.48 5.8,6.48 C2.59888333,6.48 0,9.06096 0,12.24 C0,15.41904 2.59888333,18 5.8,18 C9.00111667,18 11.6,15.41904 11.6,12.24 C11.6,10.36224 10.6932667,8.6928 9.29063333,7.64112 L10.12245,6.21024 L13.8238167,12.57648 C13.9030833,12.7128 14.0210167,12.81408 14.1558667,12.8736 C14.2583333,12.9288 14.3753,12.96 14.5,12.96 L17.44495,12.96 C17.8021333,15.79968 20.2444167,18 23.2,18 C26.4011167,18 29,15.41904 29,12.24 C29,9.06096 26.4011167,6.48 23.2,6.48 C22.4025,6.48 21.6422167,6.64032 20.9500833,6.93024 L20.0655833,5.40864 L20.5590667,4.56 L21.5373333,4.56 C21.9882833,4.56 22.3541667,4.19664 22.3541667,3.7488 C22.3541667,3.42144 22.3541667,3.12 22.3541667,3.12 C22.3541667,3.12 19.8988333,3.12 18.5793333,3.12 C18.1283833,3.12 17.7625,3.48336 17.7625,3.9312 C17.7625,4.25856 17.7625,4.56 17.7625,4.56 L18.8848,4.56 L14.88135,11.44608 C14.8745833,11.45808 14.8678167,11.47008 14.8620167,11.48208 L10.9595833,4.77024 L12.8958167,1.44 L12.8958167,1.44 Z M21.6828167,8.19024 C22.1555167,8.01552 22.6664,7.92 23.2,7.92 C25.6007167,7.92 27.55,9.85584 27.55,12.24 C27.55,14.62416 25.6007167,16.56 23.2,16.56 C21.0462667,16.56 19.256,15.00192 18.9104167,12.96 L23.2,12.96 L23.2009667,12.96 C23.2551,12.96 23.3092333,12.95376 23.3628833,12.94176 L23.36385,12.94176 L23.36385,12.94176 L23.36385,12.94128 L23.3648167,12.94128 C23.4411833,12.92352 23.5127167,12.89424 23.5774833,12.85488 C23.68285,12.79104 23.7664667,12.70416 23.82495,12.6048 C23.8882667,12.49872 23.9245167,12.3744 23.925,12.2424 L23.925,12.2424 L23.925,12.2424 L23.925,12.24 L23.925,12.23904 C23.925,12.1824 23.9182333,12.12528 23.9042167,12.06912 L23.9042167,12.06864 L23.9042167,12.06864 L23.9042167,12.06864 L23.9037333,12.0672 C23.8873,11.99952 23.8607167,11.93568 23.8264,11.87712 L21.6828167,8.19024 L21.6828167,8.19024 Z M8.55838333,8.90064 C9.52988333,9.69312 10.15,10.89504 10.15,12.24 C10.15,14.62416 8.20071667,16.56 5.8,16.56 C3.39928333,16.56 1.45,14.62416 1.45,12.24 C1.45,9.85584 3.39928333,7.92 5.8,7.92 C6.32731667,7.92 6.83288333,8.0136 7.30075,8.18448 L5.11173333,11.9496 C4.91163333,12.29376 5.03053333,12.7344 5.37708333,12.93312 C5.72363333,13.13184 6.16733333,13.01376 6.36743333,12.6696 L8.55838333,8.90064 L8.55838333,8.90064 Z M17.44495,11.52 L16.5126,11.52 L19.22845,6.84864 L19.69535,7.65168 C18.4826667,8.56656 17.6431167,9.94512 17.44495,11.52 Z M20.4280833,8.91168 L21.9443,11.52 L18.9104167,11.52 C19.0868333,10.47648 19.6407333,9.5592 20.4280833,8.91168 Z"
              id="bike1"></path>
          <path
              d="M36.1594203,12.8353957 L32.0405797,8.865914 C31.6202899,8.4344486 31.0318841,8.17556936 30.3594203,8.17556936 C28.173913,8.17556936 23.2985507,8.17556936 21.1971014,8.17556936 C20.4405797,8.17556936 19.7681159,8.4344486 19.3478261,9.03850017 L15.8173913,12.8353957 C15.5652174,13.094275 15.2289855,13.2668611 14.8927536,13.2668611 L11.7826087,13.2668611 C9.68115942,13.2668611 8,14.9927227 8,17.1500498 L8,18.7033252 C8,20.5154799 9.42898551,21.2921176 11.026087,21.2921176 C11.3623188,22.6728069 12.7072464,23.794617 14.2202899,23.794617 C15.7333333,23.794617 17.0782609,22.6728069 17.4144928,21.2921176 L27.5855072,21.2921176 C28.0057971,22.6728069 29.2666667,23.794617 30.7797101,23.794617 C32.3768116,23.794617 33.6376812,22.6728069 34.057971,21.2921176 C35.5710145,21.2921176 37,20.5154799 37,18.7033252 L37,14.7338435 C37,14.0434989 36.7478261,13.3531542 36.1594203,12.8353957 Z M30.3594203,9.46996557 C30.6956522,9.46996557 31.0318841,9.55625865 31.2,9.81513789 L34.8144928,13.2668611 L30.4434783,13.2668611 L28.7623188,9.46996557 L30.3594203,9.46996557 Z M29.1826087,13.2668611 L24.8115942,13.2668611 L24.8115942,9.46996557 L27.4173913,9.46996557 L29.1826087,13.2668611 Z M20.1884058,9.81513789 C20.4405797,9.55625865 20.7768116,9.46996557 21.1971014,9.46996557 L23.6347826,9.46996557 L23.6347826,13.2668611 L17.1623188,13.2668611 L20.1884058,9.81513789 Z M14.2202899,22.5865138 C13.0434783,22.5865138 12.1188406,21.5509969 12.1188406,20.4291868 C12.1188406,19.2210837 13.0434783,18.1855667 14.2202899,18.1855667 C15.3971014,18.1855667 16.3217391,19.2210837 16.3217391,20.4291868 C16.3217391,21.5509969 15.3971014,22.5865138 14.2202899,22.5865138 Z M23.6347826,19.9977214 L17.4985507,19.9977214 C17.3304348,18.2718598 15.9014493,16.9774636 14.2202899,16.9774636 C12.5391304,16.9774636 11.1101449,18.2718598 10.942029,19.9977214 C10.0173913,19.9977214 9.26086957,19.7388422 9.17681159,18.7033252 L9.17681159,17.1500498 C9.26086957,15.6830674 10.3536232,14.4749643 11.7826087,14.4749643 C15.7333333,14.4749643 19.684058,14.4749643 23.6347826,14.4749643 L23.6347826,19.9977214 Z M30.8637681,22.5865138 C29.6869565,22.5865138 28.6782609,21.5509969 28.6782609,20.4291868 C28.6782609,19.2210837 29.6869565,18.1855667 30.8637681,18.1855667 C31.9565217,18.1855667 32.9652174,19.2210837 32.9652174,20.4291868 C32.9652174,21.5509969 31.9565217,22.5865138 30.8637681,22.5865138 Z M35.8231884,18.7033252 C35.7391304,19.7388422 34.9826087,19.9977214 34.142029,19.9977214 C33.8898551,18.0992736 32.2927536,16.8048774 30.4434783,16.9774636 C28.9304348,17.1500498 27.6695652,18.444446 27.5014493,19.9977214 L24.8115942,19.9977214 L24.8115942,14.4749643 L35.3188406,14.4749643 C35.5710145,14.4749643 35.7391304,14.7338435 35.7391304,14.9927227 L35.8231884,18.7033252 Z"
              id="car1"></path>
          <rect x="4.5" y="4.5" width="36" height="24"
                id="iconRect"></rect>

          <g id="pauseIcon">
            <path
                d="M15.7594781,0.003075225 L16.2729675,0.00258792841 C17.7753344,0.00116219619 18.9943993,1.21791548 18.995825,2.72028244 C18.9958272,2.72253181 18.9958265,2.72478119 18.9958231,2.72703056 L18.9582144,27.2808153 C18.9559173,28.7805466 17.7402542,29.9955015 16.2405219,29.9969248 L15.7270325,29.9974121 C14.2246656,29.9988378 13.0056007,28.7820845 13.004175,27.2797176 C13.0041728,27.2774682 13.0041735,27.2752188 13.0041769,27.2729694 L13.0417856,2.71918466 C13.0440827,1.2194534 14.2597458,0.00449845699 15.7594781,0.003075225 Z"></path>
            <path
                d="M2.75947813,0.003075225 L3.27296747,0.00258792841 C4.77533444,0.00116219619 5.99439929,1.21791548 5.99582502,2.72028244 C5.99582715,2.72253181 5.9958265,2.72478119 5.99582305,2.72703056 L5.95821442,27.2808153 C5.9559173,28.7805466 4.74025421,29.9955015 3.24052187,29.9969248 L2.72703253,29.9974121 C1.22466556,29.9988378 0.00560071483,28.7820845 0.0041749826,27.2797176 C0.00417284797,27.2774682 0.00417350332,27.2752188 0.00417694864,27.2729694 L0.041785584,2.71918466 C0.0440826981,1.2194534 1.25974579,0.00449845699 2.75947813,0.003075225 Z"></path>
          </g>

          <circle
              id="whiteDisc"
              fill-rule="evenodd"
              cx="0"
              cy="0"
              r="12"
              fill="white"/>

          <linearGradient x1="0%" y1="50%" x2="99%" y2="50%" id="gradBgActive">
            <stop stop-color="#B9D400" stop-opacity="0" offset="0%"></stop>
            <stop stop-color="#B9D400" offset="12%"></stop>
            <stop stop-color="#B9D400" offset="90%"></stop>
            <stop stop-color="#B9D400" stop-opacity="0" offset="100%"></stop>
          </linearGradient>
          <linearGradient x1="100%" y1="75%" x2="0%" y2="75%" id="gradOverActive">
            <stop stop-color="#B9D400" stop-opacity="0" offset="0%"></stop>
            <stop stop-color="#B9D400" offset="2.3%"></stop>
            <stop stop-color="#B9D400" offset="96%"></stop>
            <stop stop-color="#B9D400" stop-opacity="0" offset="100%"></stop>
          </linearGradient>

          <linearGradient x1="0%" y1="50%" x2="99%" y2="50%" id="gradBgInactive">
            <stop stop-color="#A6CFB7" stop-opacity="0" offset="0%"></stop>
            <stop stop-color="#A6CFB7" offset="12%"></stop>
            <stop stop-color="#A6CFB7" offset="90%"></stop>
            <stop stop-color="#A6CFB7" stop-opacity="0" offset="100%"></stop>
          </linearGradient>
          <linearGradient x1="100%" y1="75%" x2="0%" y2="75%" id="gradOverInactive">
            <stop stop-color="#A6CFB7" stop-opacity="0" offset="0%"></stop>
            <stop stop-color="#A6CFB7" offset="2.3%"></stop>
            <stop stop-color="#A6CFB7" offset="96%"></stop>
            <stop stop-color="#A6CFB7" stop-opacity="0" offset="100%"></stop>
          </linearGradient>

          <filter x="-16.2%" y="-24.0%" width="132.4%" height="148.0%" filterUnits="objectBoundingBox"
                  id="blurIconRect">
            <feOffset dx="0" dy="0" in="SourceAlpha" result="shadowOffsetOuter1"></feOffset>
            <feMorphology radius="1" operator="erode" in="SourceAlpha" result="shadowInner"></feMorphology>
            <feOffset dx="0" dy="0" in="shadowInner" result="shadowInner"></feOffset>
            <feComposite in="shadowOffsetOuter1" in2="shadowInner" operator="out"
                         result="shadowOffsetOuter1"></feComposite>
            <feGaussianBlur stdDeviation="2" in="shadowOffsetOuter1" result="shadowBlurOuter1"></feGaussianBlur>
            <feColorMatrix values="0 0 0 0 0.725490196   0 0 0 0 0.831372549   0 0 0 0 0  0 0 0 1 0" type="matrix"
                           in="shadowBlurOuter1"></feColorMatrix>
          </filter>

          <filter x="-20.7%" y="-33.3%" width="141.4%" height="166.7%" filterUnits="objectBoundingBox"
                  id="blurCar1">
            <feOffset dx="0" dy="0" in="SourceAlpha" result="shadowOffsetOuter1"></feOffset>
            <feGaussianBlur stdDeviation="2" in="shadowOffsetOuter1" result="shadowBlurOuter1"></feGaussianBlur>
            <feColorMatrix values="0 0 0 0 0.725490196   0 0 0 0 0.831372549   0 0 0 0 0  0 0 0 1 0" type="matrix"
                           in="shadowBlurOuter1"></feColorMatrix>
          </filter>

          <filter x="-20.7%" y="-33.3%" width="141.4%" height="166.7%" filterUnits="objectBoundingBox"
                  id="blurBike1">
            <feOffset dx="0" dy="0" in="SourceAlpha" result="shadowOffsetOuter1"></feOffset>
            <feGaussianBlur stdDeviation="2" in="shadowOffsetOuter1" result="shadowBlurOuter1"></feGaussianBlur>
            <feColorMatrix values="0 0 0 0 0.725490196   0 0 0 0 0.831372549   0 0 0 0 0  0 0 0 1 0" type="matrix"
                           in="shadowBlurOuter1"></feColorMatrix>
          </filter>

        </defs>
      </svg>

      <div class="pbPause" @click.prevent.stop="$emit('toggle-play')">
        <button class="icon">
          <img v-show="!isPaused" src="../assets/icons_UI_pause.svg" alt=""/>
          <img class="pbPlay" v-show="isPaused" src="../assets/play.svg" alt=""/>
        </button>
      </div>
      <div class="pbFull" @click.prevent.stop="$emit('toggle-full')">
        <button class="icon">
          <img v-show="!isFull" src="../assets/fullscreen.svg" alt=""/>
          <img v-show="isFull" src="../assets/fullscreen_back.svg" alt=""/>
        </button>
      </div>


      <!-- ######################## CAR ###################### -->
      <div class="pbCarBar pbComponent">

        <div class="pbIcon" @click.prevent.stop="$emit('toggle-car')">
          <svg viewBox="0 0 37 25" overflow="visible">
            <g fill="none" transform="translate(-4.000000, -4.000000)" :opacity="perspective === 'car' ? 1 : 0.6">
              <g transform="translate(20, 10) scale(-1, 1) translate(-25, -9) ">
                <use class="icnBlur" fill="black" filter="url(#blurCar1)" xlink:href="#car1"></use>
                <use class="icnPath" fill="#A6CFB7" xlink:href="#car1"></use>
              </g>
              <g>
                <use class="icnBlur" fill="black" filter="url(#blurIconRect)" xlink:href="#iconRect"></use>
                <use class="icnRect" stroke="#A6CFB7" xlink:href="#iconRect"></use>
              </g>
            </g>
          </svg>
        </div>

        <div class="pbBar">

          <!-- background -->
          <svg class="barSvg" viewBox="0 0 1311 60">
            <g
                transform="translate(0, 15)"
                class="active"
                fill-opacity="0.6">
              <use fill="url(#gradBgActive)" xlink:href="#bar1"></use>
            </g>
            <g
                transform="translate(0, 15)"
                class="inactive"
                fill-opacity="0.3">
              <use fill="url(#gradBgInactive)" xlink:href="#bar1"></use>
            </g>
          </svg>

          <!-- OVERLAY -->
          <svg class="barSvg" id="pbOver1" viewBox="0 0 1312 60">
            <defs>
              <clipPath id="watchedCar">
                <rect v-for="c in clippingsCar"
                      :x="c.pos"
                      height="100%"
                      :width="c.width"></rect>
              </clipPath>
            </defs>
            <g clip-path="url(#watchedCar)">
              <g class="active"
                 transform="translate(-54.0, -990.0)"
                 fill="url(#gradOverActive)"
                 fill-opacity="0.7"
              >
                <use xlink:href="#pCar"></use>
              </g>
              <g class="inactive"
                 transform="translate(-54.0, -990.0)"
                 fill="url(#gradOverInactive)"
                 fill-opacity="0.7"
              >
                <use xlink:href="#pCar"></use>
              </g>
            </g>
          </svg>

          <svg class="carBarElems"
               viewBox="0 0 1312 80"
               overflow="visible"
          >

            <!-- discovered questions -->
            <g>
              <rect
                  transform="translate(10, -4)"
                  v-for="q in discoveredCar"
                  :x="q.cx"
                  :y="q.cy"
                  width="3"
                  height="18"
                  fill="white"></rect>
              <use
                  transform="translate(-1, -29)"
                  v-for="q in discoveredCar"
                  :x="q.cx"
                  :y="q.cy"
                  xlink:href="#exclaMarkSmall" fill="white"></use>
            </g>

            <!-- Abspielknopf (car) -->
            <g v-show="perspective === 'car'">
              <!-- hot -->
              <svg
                  class="alertBtn"
                  v-bind:class="{ 'blinky': blink }"
                  v-show="showAlert && !isPaused"
                  overflow="visible"
                  :x="playCar.cx"
                  :y="playCar.cy">
                <g>
                  <g transform="translate(-28, -54)" fill="#FFF">
                    <use xlink:href="#exclaMark"></use>
                  </g>
                </g>
              </svg>
              <!-- normal/paused -->
              <svg
                  v-show="!showAlert || (showAlert && isPaused)"
                  overflow="visible"
                  :x="playCar.cx"
                  :y="playCar.cy">
                <use
                    transform="translate(10, -4.5)"
                    xlink:href="#whiteDisc"/>
                <use
                    v-show="isPaused"
                    xlink:href="#pauseIcon"
                    transform="translate(5.5, -11.5) scale(0.5, 0.5)"
                    fill="#404040"/>
              </svg>
            </g>

          </svg>

        </div>

      </div>

      <!-- ######################## BIKE ###################### -->

      <div class="pbBikeBar pbComponent">

        <div class="pbIcon" @click.prevent.stop="$emit('toggle-bike')">
          <svg viewBox="0 0 37 25" overflow="visible">
            <g fill="none" transform="translate(-4.000000, -4.000000)" :opacity="perspective === 'bike' ? 1 : 0.6">
              <g transform="translate(20, 10) scale(-1, 1) translate(-17, -3) ">
                <use class="icnBlur" fill="black" filter="url(#blurBike1)" xlink:href="#bike1"></use>
                <use class="icnPath" fill="#A6CFB7" xlink:href="#bike1"></use>
              </g>
              <g>
                <use class="icnBlur" fill="black" filter="url(#blurIconRect)" xlink:href="#iconRect"></use>
                <use class="icnRect" stroke="#A6CFB7" xlink:href="#iconRect"></use>
              </g>
            </g>
          </svg>
        </div>

        <div class="pbBar">

          <!-- background -->
          <svg class="barSvg" viewBox="0 0 1311 60">
            <g transform="translate(0, 4)"
               class="active"
               fill-opacity="0.6">
              <use fill="url(#gradBgActive)"
                   xlink:href="#bar1"></use>
            </g>
            <g transform="translate(0, 4)"
               class="inactive"
               fill-opacity="0.3">
              <use fill="url(#gradBgInactive)"
                   xlink:href="#bar1"></use>
            </g>
          </svg>

          <!-- OVERLAY -->
          <svg class="barSvg" id="pbOver2" viewBox="0 0 1312 40">
            <defs>
              <clipPath id="watchedBike">
                <rect
                    v-for="c in clippingsBike"
                    :x="c.pos"
                    height="100%"
                    :width="c.width"></rect>
              </clipPath>
            </defs>
            <g clip-path="url(#watchedBike)">
              <g class="active"
                 transform="translate(-54.0, -1001.0)"
                 fill="url(#gradOverActive)"
                 fill-opacity="0.7"
              >
                <use xlink:href="#pBike"></use>
              </g>
              <g class="inactive"
                 transform="translate(-54.0, -1001.0)"
                 fill="url(#gradOverInactive)"
                 fill-opacity="0.7"
              >
                <use xlink:href="#pBike"></use>
              </g>
            </g>
          </svg>

          <svg class="bikeBarElems"
               viewBox="0 0 1312 80"
               overflow="visible"
          >

            <!-- discovered questions -->
            <g>
              <rect
                  transform="translate(10, -4)"
                  v-for="q in discoveredBike"
                  :x="q.cx"
                  :y="q.cy"
                  width="3"
                  height="18"
                  fill="white"></rect>
              <use
                  transform="translate(-1, 20)"
                  v-for="q in discoveredBike"
                  :x="q.cx"
                  :y="q.cy"
                  xlink:href="#exclaMarkSmall" fill="white"></use>
            </g>

            <!-- Abspielknopf (bike) -->
            <g v-show="perspective === 'bike'">
              <!-- hot -->
              <svg
                  class="alertBtn"
                  v-bind:class="{ 'blinky': blink }"
                  v-show="showAlert && !isPaused"
                  overflow="visible"
                  :x="playBike.cx"
                  :y="playBike.cy">
                <g>
                  <g transform="translate(-28, -54)" fill="#FFF">
                    <use xlink:href="#exclaMark"></use>
                  </g>
                </g>
              </svg>
              <!-- normal/paused -->
              <svg
                  v-show="!showAlert || (showAlert && isPaused)"
                  overflow="visible"
                  :x="playBike.cx"
                  :y="playBike.cy">
                <use
                    transform="translate(10, -4)"
                    xlink:href="#whiteDisc"/>
                <use
                    v-show="isPaused"
                    xlink:href="#pauseIcon"
                    transform="translate(5.5, -11) scale(0.5, 0.5)"
                    fill="#404040"/>
              </svg>
            </g>
          </svg>

          <div id="ctrlKey"
               v-bind:class="{ 'blinky': blink && !isPaused }"
               v-show="showAlert && !blocked"
               :style="ctrlKey.cx"
          >
            <img src="../assets/altOpt.svg" alt=""/>
          </div>
        </div>

      </div>

      <div class="pbKeyboardKeys">

        <div>
          <img src="../assets/strgCtrl.svg" alt=""/>
        </div>
        <img src="../assets/space_key.svg" alt=""/>

      </div>

    </div>

    <div class="pbMargin2"></div>

  </div>

</template>

<style lang="scss">

$vhUnit: 9;
$vwUnit: 16;
$vhUnitMobile: 3.75;
$vwUnitMobile: 6.66;

@function scaleVh($size) {
  @return #{($size/$vhUnit)}vh;
}
@function scaleVw($size) {
  @return #{($size/$vwUnit)}vw;
}
@function scaleMobileVh($size) {
  @return #{($size/$vhUnitMobile)}vh;
}
@function scaleMobileVw($size) {
  @return #{($size/$vwUnitMobile)}vw;
}

.pbContainer {
  display: flex;
  flex-direction: row;
}

.pbInner1 {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.pbKeyboardKeys {
  display: flex;
  justify-content: space-between;
  color: #FFF;
}

.pbComponent {
  display: flex;
  flex-direction: row;
}

.pbIcon {
  position: relative;
}

.pbIcon svg {
  cursor: pointer;
  position: absolute;
}

.pbBar {
  position: relative;
}

.pbBar svg {
  width: 100%;
  position: absolute;
}

#ctrlKey {
  position: absolute;
  left: 50%;
  font-weight: bold;
  color: #FFF;
}

.time {
  position: absolute;
  color: #FFF;
  z-index: 999;
}

.alertBtn {
  > g {
    transform: scale(0.3);
    animation-fill-mode: forwards;
    animation-name: fadeIn;
    animation-iteration-count: 1;
    animation-timing-function: ease-in;
    animation-duration: 4s;
  }
}

@keyframes fadeIn {
  0% {
    transform: scale(0.3);
  }
  100% {
    transform: scale(0.4);
  }
}

.blinky {
  animation: blinky 0.25s linear infinite;
}

@keyframes blinky {
  0% {
    opacity: 0.5;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0.5;
  }
}


.car .pbCarBar .active {
  display: inline;
}

.car .pbCarBar .inactive {
  display: none;
}

.car .pbBikeBar .active {
  display: none;
}

.car .pbBikeBar .inactive {
  display: inline;
}

.bike .pbCarBar .active {
  display: none;
}

.bike .pbCarBar .inactive {
  display: inline;
}

.bike .pbBikeBar .active {
  display: inline;
}

.bike .pbBikeBar .inactive {
  display: none;
}

.car .pbCarBar .icnPath {
  fill: #B9D400;
}

.car .pbCarBar .icnRect {
  stroke: #B9D400;
}

.bike .pbBikeBar .icnPath {
  fill: #B9D400;
}

.bike .pbBikeBar .icnRect {
  stroke: #B9D400;
}

.car .pbBikeBar .icnBlur {
  display: none;
}

.car .pbBikeBar .icnRect {
  stroke: #A6CFB7;
}

.bike .pbCarBar .icnBlur {
  display: none;
}

.bike .pbCarBar .icnRect {
  stroke: #A6CFB7;
}

.pbFull,
.pbPause {
  justify-content: center;
  position: absolute;
  right: 0;
  top: 0;
}

.mobile {
  .pbKeyboardKeys,
  #ctrlKey {
    display: none;
  }
}

@media(min-aspect-ratio: 16/9) {

  .pbFull,
  .pbPause {
    right: scaleVh(30);

    button.icon {
      margin-top: scaleVh(17);
    }

    button.icon img {
      width: auto;
      height: scaleVh(18);
    }

    button.icon img.pbPlay {
      width: auto;
      height: scaleVh(22);
      margin-left: scaleVh(2);
    }
  }
  .pbPause {
    right: scaleVh(74);
  }

  .pbMargin1 {
    width: scaleVh(34);
  }
  .pbIcon {
    height: scaleVh(20);
    margin-bottom: scaleVh(20);
  }
  .pbIcon,
  .pbIcon svg {
    width: scaleVh(37);
  }
  .pbBar {
    width: scaleVh(1600 - 161);
  }
  .pbPause {
    width: scaleVh(30);
  }
  .pbPause img {
    width: scaleVh(30);
  }
  .pbMargin2 {
    width: scaleVh(30);
  }
  .time {
    right: scaleVh(30);
    font-size: scaleVh(16);
    margin-top: scaleVh(-3);
  }

  .pbKeyboardKeys {
    opacity: 0.5;
    margin-top: scaleVh(16);
    margin-bottom: scaleVh(20);

    div {
      display: flex;

      span {
        padding: scaleVh(8);
        font-weight: bold;
        font-size: scaleVh(10.8);
      }

      height: scaleVh(27);
    }
  }
  #ctrlKey img,
  .pbKeyboardKeys img {
    height: scaleVh(27);
  }

  #ctrlKey {
    display: flex;

    span {
      padding: scaleVh(8);
      font-size: scaleVh(10.8);
    }

    margin-top: scaleVh(55);
    margin-left: scaleVh(-44);
  }

  // mobile ---------------

  .mobile {
    .pbFull,
    .pbPause {
      right: scaleMobileVh(26);
      button.icon {
        margin-top: scaleMobileVh(2);
      }
      button.icon img {
        width: scaleMobileVh(13);
        height: scaleMobileVh(13);
      }
      button.icon img.pbPlay {
        width: auto;
        height: scaleMobileVh(14);
        margin-top: 0;
      }
      margin-top: scaleMobileVh(18);
      width: scaleMobileVh(23);
      img {
        width: scaleMobileVh(23);
      }
    }
    .pbPause {
      right: scaleMobileVh(52);
    }
    .pbMargin1 {
      width: scaleMobileVh(15);
    }
    .pbIcon {
      height: scaleMobileVh(24);
      margin-bottom: scaleMobileVh(5);
    }
    .pbIcon,
    .pbIcon svg {
      width: scaleMobileVh(42);
    }
    .pbBar {
      width: scaleMobileVh(667 - (15 + 42 + 23 + 26 + 23));
    }
    .time {
      right: scaleMobileVh(26);
      font-size: scaleMobileVh(12);
      line-height: 150%;
      margin-top: 0;
    }
    .pbCarBar {
      margin-bottom: scaleMobileVh(10);
      .pbBar {
        margin-top: scaleMobileVh(16);
      }
    }
    .pbBikeBar {
      margin-bottom: scaleMobileVh(10);
    }
  }

}

@media(max-aspect-ratio: 16/9) {

  .pbFull,
  .pbPause {
    right: scaleVw(30);

    button.icon {
      margin-top: scaleVw(17);
    }

    button.icon img {
      width: auto;
      height: scaleVw(18);
    }

    button.icon img.pbPlay {
      width: auto;
      height: scaleVw(22);
      margin-top: scaleVw(3);
      margin-left: scaleVw(2);
    }
  }
  .pbPause {
    right: scaleVw(74);
  }

  .pbMargin1 {
    width: scaleVw(34);
  }
  .pbIcon {
    height: scaleVw(20);
    margin-bottom: scaleVw(20);
  }
  .pbIcon, .pbIcon svg {
    width: scaleVw(37);
  }
  .pbBar {
    width: scaleVw(1600 - 161);
  }

  .pbPause {
    width: scaleVw(30);
  }
  .pbPause img {
    width: scaleVw(30);
  }
  .pbMargin2 {
    width: scaleVw(30);
  }
  .time {
    right: scaleVw(30);
    font-size: scaleVw(16);
    margin-top: scaleVw(-3);
  }

  .pbCarBar {
    //margin-bottom: scaleVw(6);
  }
  .pbBikeBar {
    //margin-bottom: scaleVw(14);
  }
  .pbKeyboardKeys {
    opacity: 0.5;
    margin-top: scaleVw(16);
    margin-bottom: scaleVw(20);

    div {
      display: flex;

      span {
        padding: scaleVw(8);
        font-weight: bold;
        font-size: scaleVw(10.8);
      }

      height: scaleVw(27);
    }
  }
  #ctrlKey img,
  .pbKeyboardKeys img {
    height: scaleVw(27);
  }

  #ctrlKey {
    display: flex;

    span {
      padding: scaleVw(8);
      font-size: scaleVw(10.8);
    }

    margin-top: scaleVw(55);
    margin-left: scaleVw(-44);
  }

  .mobile {
    .pbFull,
    .pbPause {
      right: scaleMobileVw(26);
      button.icon {
        margin-top: scaleMobileVw(2);
      }
      button.icon img {
        width: scaleMobileVw(13);
        height: scaleMobileVw(13);
      }
      button.icon img.pbPlay {
        width: auto;
        height: scaleMobileVw(14);
        margin-top: 0;
      }
      margin-top: scaleMobileVw(18);
      width: scaleMobileVw(23);
      img {
        width: scaleMobileVw(23);
      }
    }
    .pbPause {
      right: scaleMobileVw(52);
    }
    .pbMargin1 {
      width: scaleMobileVw(15);
    }
    .pbIcon {
      height: scaleMobileVw(24);
      margin-bottom: scaleMobileVw(5);
    }
    .pbIcon,
    .pbIcon svg {
      width: scaleMobileVw(42);
    }
    .pbBar {
      width: scaleMobileVw(667 - (15 + 42 + 23 + 26 + 23));
    }
    .time {
      right: scaleMobileVw(26);
      font-size: scaleMobileVw(12);
      line-height: 150%;
      margin-top: 0;
    }
    .pbCarBar {
      margin-bottom: scaleMobileVw(10);
      .pbBar {
        margin-top: scaleMobileVw(16);
      }
    }
    .pbBikeBar {
      margin-bottom: scaleMobileVw(10);
    }
  }
}


</style>